import clsx from 'clsx'
import { ReactNode } from 'react'

import { useRadioGroup } from '../RadioGroup/RadioGroup'

import cls from './RadioButton.module.scss'

interface RadioButtonProps {
	value: string
	children: ReactNode
	className?: string
	disabled?: boolean
}

export const RadioButton = ({ value, children, className, disabled }: RadioButtonProps) => {
	const group = useRadioGroup()
	const isChecked = group?.value === value

	const handleChange = () => {
		if (disabled) return
		group?.onChange?.(value)
	}

	const rootClasses = clsx(
		cls.radioButton,
		{
			[cls.radioButton__checked]: isChecked,
			[cls.radioButton__disabled]: disabled,
			[cls.radioButton__solid]: group?.buttonStyle === 'solid'
		},
		className
	)

	return (
		<label className={rootClasses}>
			<input
				type="radio"
				value={value}
				checked={isChecked}
				disabled={disabled}
				onChange={handleChange}
				className={cls.radioButton__input}
				name={group?.name}
			/>
			<span className={cls.radioButton__content}>{children}</span>
		</label>
	)
}

RadioButton.displayName = 'RadioButton'
